export default __webpack_public_path__ + "static/media/money-back@3x.989c4b2a.png";